// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","682":"component---src-pages-about-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"6349a895c2811a3e4a4d","682":"1950368d4ceea9ca0b3e","883":"670317ecc4b800e483a0"}[chunkId] + ".js";
};